import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Slot } from './';

class BannerAd extends Component {

    render () {

        const { slotId } = this.props;

        return (
            <div>
                <Slot slotId={ slotId } />
            </div>
        )

    }
}

BannerAd.propTypes = {
    network: PropTypes.string.isRequired,
    slotId: PropTypes.number.isRequired,
};

export default BannerAd;


// WEBPACK FOOTER //
// src/client/components/common/elements/BannerAd.js